import type { EventKey } from "../../event/server/supabase-event-service";
import type { MomentFormSurvey } from "../server/supabase-survey-service";

export const SURVEY_COMPLETED_PREFIX = "ce-survey-completed-";

export const isSurveyCompletedKey = (key: string): boolean =>
  key.startsWith(SURVEY_COMPLETED_PREFIX);

export const surveyIdFromKey = (key: string): string => key.replace(SURVEY_COMPLETED_PREFIX, "");

export const surveyToEventKey = (survey: MomentFormSurvey): EventKey => ({
  key: `${SURVEY_COMPLETED_PREFIX}${survey.id}`,
  title: survey.title ?? "",
  calendar: false,
  allow_initial: true,
  allow_repeats: false,
  has_schedule_event: true,
  library: false,
  repeat: null,
  number_of_repeats: undefined,
});
